import { render } from "./TheUsersAtRiskList.vue?vue&type=template&id=64f3cd38"
import script from "./TheUsersAtRiskList.vue?vue&type=script&lang=js"
export * from "./TheUsersAtRiskList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__